import { render, staticRenderFns } from "./SidebarNavDropdown.vue?vue&type=template&id=3b429186&"
import script from "./SidebarNavDropdown.vue?vue&type=script&lang=js&"
export * from "./SidebarNavDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b429186')) {
      api.createRecord('3b429186', component.options)
    } else {
      api.reload('3b429186', component.options)
    }
    module.hot.accept("./SidebarNavDropdown.vue?vue&type=template&id=3b429186&", function () {
      api.rerender('3b429186', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Forks/SidebarNavDropdown.vue"
export default component.exports